import { useMemo } from 'react';
import { useEventQuestions } from './useEventQuestions';


export function useEventQuestion(eventId, questionId) {
    const questions = useEventQuestions(eventId);
    return useMemo(() => (questionId ? questions.find(q => q.id == questionId) : null), [questions, questionId]);
}